/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
namespace('Slzr.Page', function(exports, top) {
  const $ = Slzr.jQuery;

  // Disable all links for the event preview
  exports.disableEventPreviewLinks = function() {
    $(document.body).on('click', 'a, input[type="submit"], button[type="submit"]', event => event.preventDefault());

    return $(document.body).on('click', 'a[data-method], a[data-remote]', event => event.stopPropagation());
  };

  return $(function() {
    const $container = $('[data-event-feedback]');
    const $form_container = $container.find('[data-event-feedback="form-container"]');

    // Only activate on pages that have a feedback form
    if ($container.length === 0) { return; }

    // utility functions
    const setStatus = status => $container
      .removeClass('em-event-feedback--status-complete em-event-feedback--status-ignored em-event-feedback--status-declined')
      .addClass(`em-event-feedback--status-${status}`);

    const openForm = () => $form_container.addClass('em-event-feedback--open').removeClass('em-event-feedback--closed');
    const closeForm = () => $form_container.removeClass('em-event-feedback--open').addClass('em-event-feedback--closed');

    // event handlers
    $container.on('click', '[data-event-feedback-action="open-survey"]', function(ev) {
      ev.preventDefault();
      return openForm();
    });

    $container.on('click', '[data-event-feedback-action="close-survey"]', function(ev) {
      ev.preventDefault();
      return closeForm();
    });

    $container.on('click', '[data-event-feedback-action="show-feedback-form"]', function(ev) {
      ev.preventDefault();
      setStatus('pending');
      return openForm();
    });

    // On an event page preview with the form, disable most links and submit buttons
    if (LOCALIST_SETTINGS.event_page_preview) {
      return exports.disableEventPreviewLinks();
    }
  });
});
